module.exports = __webpack_public_path__ + "static/media/gabriel-color.8b25e37c.jpg";